import PageContainer from '@/common/components/PageContainer'
import withUserPermission from '@/common/components/WithUserPermission'
import { PermissionType } from '@/common/types'
import { PermissionKeys } from '@/modules/manage-member/mappers'
import EditPartnerListing from '@/modules/manage-player/components/EditPartner/EditPartnerListing'

function EditPartnerPage() {
	return (
		<PageContainer>
			<EditPartnerListing />
		</PageContainer>
	)
}

const GuardedEditPartnerPage = withUserPermission(EditPartnerPage, {
	permissionType: PermissionType.Write,
	permissionKey: [PermissionKeys.MANAGE_PLAYER],
})

export default GuardedEditPartnerPage
